<template>
  <div class="box-input">
    <!-- 账号 -->
    <el-input
      v-model="myemail"
      placeholder="请输入邮箱"
      :prefix-icon="Message"
      autocomplete="off"
      :class="{ 'focus-border': mydata.focusEmail }"
      @focus="mydata.focusEmail = true"
      @blur="mydata.focusEmail = false"
    />

    <!-- 密码 -->
    <div class="box-password">
      <el-input
        class="password-input"
        v-model="myemailcode"
        placeholder="请输入邮箱验证码"
        :class="{ 'focus-border': mydata.focusCode }"
        @focus="mydata.focusCode = true"
        @blur="mydata.focusCode = false"
      />
      <el-button
        class="password-button"
        @click="submit"
        :disabled="mydata.btnDisabled"
        >{{ mydata.btnText }}</el-button
      >
    </div>
  </div>
</template>

<script setup>
import { ref, reactive } from "vue";
import { ElMessage } from "element-plus";
import { useRouter } from "vue-router";
import { Message, Lock } from "@element-plus/icons-vue";

// 引入邮箱验证码发送接口
import { forgetPasswordCode } from "@/api/login/retrievePasswordLogin/index.js";

//验证是否为邮箱
import { isEmail } from "@/utils/validate.js";

const router = useRouter();

// 邮箱
const myemail = defineModel("myemail");

// 验证码
const myemailcode = defineModel("myemailcode");

var mydata = reactive({
  btnText: "获取验证码",
  btnDisabled: false,

  btnLoading: false,

  form: {
    email: "",
    code: "",
  },
  ////
  focusEmail: false,
  focusCode: false,
});

//获取验证码,按钮点击事件
function submit() {
  // 如果不是邮箱，那么提醒弹窗并终止代码
  if (isEmail(myemail.value) === false) {
    ElMessage({
      message: "邮箱格式错误",
      type: "warning",
    });
    return;
  }

  mydata.btnDisabled = true;
  let num = 60;
  let intervalId = setInterval(() => {
    num = num - 1;
    mydata.btnText = num + "秒后可重发";
    if (num === 0) {
      mydata.btnText = "获取验证码";
      clearInterval(intervalId);
      mydata.btnDisabled = false;
    }
  }, 1000);

  // 调用forgetPasswordCode方法，发送请求
  forgetPasswordCode({
    type: "email",
    account: myemail.value,
  })
    .then((res) => {
      // console.log(res.data,"邮箱获取验证码")
      // 存储后端返回的用户信息
      // localStorage.setItem("userInfo", JSON.stringify(res.data));
      // // 提示弹窗
      ElMessage({
        message: res.msg,
        type: "success",
      });
      // // 跳转页面
      // router.push({
      //   path: "/login/retrievePasswordLogin",
      // });
    })
    .catch((err) => {
      mydata.btnText = "获取验证码";
      clearInterval(intervalId);
      mydata.btnDisabled = false;
    });
}
</script>

<style scoped lang="scss">
.box-input {
  ///////邮件图标
  :deep(.el-icon.el-input__icon) {
    // border:1px solid red;
    font-size: 24px;
  }

  //整个输入框
  :deep(.el-input) {
    width: 311px !important;
    height: 48px;
    border-radius: 4px;
    margin-bottom: 15px;
  }
  //整个输入框
  :deep(.el-input > .el-input__wrapper) {
    box-shadow: none;
    border: 1px solid #dbdbdb;
    // border: 1px solid red;
    > .el-input__inner {
      font-size: 15px;
      // color:red;
    }
  }

  :deep(.el-input.el-input--suffix) {
    // border:1px solid blue;
    margin-bottom: 0px;
  }
  //输入框中提示文字
  :deep(.el-input__wrapper > .el-input__inner::placeholder) {
    color: #666666;
    font-size: 14px;
    font-weight: 300;
    // color:blue;
  }

  //获取验证码盒子
  .box-password {
    display: flex;
    //账号按钮
    :deep(.el-button.is-plain) {
      // border:1px solid red;
      border: 1px solid #dbdbdb;
      width: 65px;
      height: 48px;
      border-right: 0px;
      border-radius: 4px 0px 0px 4px;
    }

    //密码按钮
    :deep(.el-button.password-button) {
      // border:1px solid red;
      border: 1px solid #dbdbdb;
      width: 100px;
      height: 48px;
      font-size: 15px;
      border-left: 0px;
      border-radius: 0px 4px 4px 0px;
      margin-bottom: 0px;
    }

    //账号输入框
    :deep(.el-input.account-input > .el-input__wrapper) {
      border-radius: 0px 4px 4px 0px;
      border: 1px solid #dbdbdb;
    }
    //密码输入框
    :deep(.el-input.password-input > .el-input__wrapper) {
      border-radius: 4px 0px 0px 4px;
      border: 1px solid #dbdbdb;
    }
  }
}

//鼠标在输入框中时，边框变蓝色
.focus-border {
  :deep(.el-input__wrapper) {
    border: 1px solid #409eff !important;
    .el-icon {
      color: #409eff;
    }
  }
}
</style>
